<div class="flex space-x-5 min-w-[16rem]">
  @if (editable()) {
    <em-tag-input (add)="add.emit($event)" [tags]="tags()" />
  }

  <div class="flex flex-wrap -m-1">
    @for (tag of tags(); track tag) {
      <div class="p-1">
        <div
          [style.border-color]="tagColorService.toColorHash(tag)"
          class="flex items-center leading-none border-2 rounded pl-2 pr-1 py-1 whitespace-nowrap truncate max-w-[10rem]"
          >
          <span (click)="searchChange.emit(tag)" class="cursor-pointer">{{tag}}</span>
          @if (editable()) {
            <button class="ml-2" type="button" (click)="remove.emit(tag)">
              <svg class="w-5 h-5 text-gray-400">
                <use xlink:href="assets/icons/symbols.svg#close"></use>
              </svg>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
